export const formatAmount = (
  amount: string | number = "",
  currencySign: string = "",
) => {
  if (amount === "") {
    return "";
  }

  const amountStr = String(amount);
  const sign = amountStr[0] === "-" ? "-" : "";
  const begin = "";
  let end = (amountStr.split(".")[1] || "00").slice(0, 2);
  end = end.length < 2 ? `${end}0` : end;
  let middle = amountStr.split(".")[0].replace("-", "");
  const parts =
    middle
      .split("")
      .reverse()
      .join("")
      .match(/.{1,3}/g) || [];
  middle = parts.join(",").split("").reverse().join("");

  return `${sign}${currencySign}${begin}${middle}.${end}`;
};

export const formatAmountAfterEditing = (amount: string = "") => {
  let newValue = "£";
  newValue += amount.replaceAll(/[^0-9/.]*/g, "");

  const arr = newValue.split(".");
  const dotExists = arr.length > 1;
  newValue = arr[0] || "";
  newValue += dotExists ? "." : "";
  newValue += arr[1]?.slice(0, 2) || "";
  newValue = newValue[1] === "." ? "" : newValue;

  const arr2 = newValue.split(".");
  const commaSeparated =
    arr2[0]
      .slice(1)
      .split(".")[0]
      .split("")
      .reverse()
      .join("")
      .match(/.{1,3}/g) || [];
  let first = "£";
  first += commaSeparated.join(",").split("").reverse().join("");
  newValue = first || "";
  newValue += arr2[1] !== undefined ? `.${arr2[1]}` : "";

  return newValue;
};

export const formatAmountOnBlur = (amount: string = "") => {
  let formattedAmount = formatAmountAfterEditing(amount);
  const arr = formattedAmount.split(".");
  if (arr.length === 1 && arr[0] === "£") {
    formattedAmount = "";
  } else if (formattedAmount[formattedAmount.length - 1] === ".") {
    formattedAmount += "00";
  } else if (arr.length === 1 && arr[0] !== "") {
    formattedAmount += ".00";
  }

  return formattedAmount;
};
